import { fetchDataStrict } from "../clients/api";
import { handleError } from "../errors";
import { Result } from "./types";
import { CacheHandle, defineCachedLookup } from "./helpers";
import { UnitSpec, UnitSpecAssociation } from "../interfaces/Unit";

const fetchUnitSpecsUncached = async (): Promise<Result<UnitSpec[]>> => {
  try {
    const response = await fetchDataStrict({
      table: "unit_specs",
    });
    const unitSpecs: UnitSpec[] = response?.data || [];
    return { success: true, data: unitSpecs };
  } catch (error) {
    const err = handleError(error, { table: "unit_specs", context: "fetchUnitSpecs" });
    return { success: false, error: err };
  }
};

const fetchUnitSpecAssociationsUncached = async (): Promise<Result<UnitSpecAssociation[]>> => {
  try {
    const response = await fetchDataStrict({
      table: "unit_spec_associations",
    });
    const unitSpecAssociations: UnitSpecAssociation[] = response?.data || [];
    return { success: true, data: unitSpecAssociations };
  } catch (error) {
    const err = handleError(error, { table: "unit_spec_associations", context: "fetchUnitSpecAssociations" });
    return { success: false, error: err };
  }
};

const unitSpecs = defineCachedLookup(fetchUnitSpecsUncached);
const unitSpecAssociations = defineCachedLookup(fetchUnitSpecAssociationsUncached);

const fetchUnitSpecs = unitSpecs.get;
const fetchUnitSpecAssociations = unitSpecAssociations.get;

export const unitCaches: CacheHandle[] = [unitSpecs, unitSpecAssociations];

export { fetchUnitSpecs, fetchUnitSpecAssociations };
